export function formatPodcastPublishedAt(
  value: string | null,
  now: Date = new Date(),
): string {
  if (!value) return "";

  const publishedAt = new Date(value);
  if (Number.isNaN(publishedAt.getTime())) return "";

  const elapsedSeconds = Math.max(0, (now.getTime() - publishedAt.getTime()) / 1_000);
  if (elapsedSeconds < 3_600) {
    const minutes = Math.max(1, Math.floor(elapsedSeconds / 60));
    return `${minutes} 分钟前`;
  }
  if (elapsedSeconds < 86_400) {
    return `${Math.floor(elapsedSeconds / 3_600)} 小时前`;
  }
  if (elapsedSeconds < 7 * 86_400) {
    return `${Math.floor(elapsedSeconds / 86_400)} 天前`;
  }

  return `${publishedAt.getMonth() + 1}月${publishedAt.getDate()}日`;
}

export function formatPodcastDuration(value: number | null): string {
  if (!value || value <= 0) return "";
  return `${Math.max(1, Math.round(value / 60))} 分钟`;
}
